import axios from "axios";
import { authConfig, endpoint } from "./http";

export async function getPrivateUserProfile({ accessToken, apiUrl }) {
  const response = await axios.get(endpoint(apiUrl, "/users/me"), authConfig(accessToken));

  return response.data;
}

export async function updatePrivateUserProfile({ accessToken, apiUrl, profile }) {
  const response = await axios.patch(
    endpoint(apiUrl, "/users/me"),
    profile,
    authConfig(accessToken),
  );

  return response.data;
}

export async function uploadPrivateUserAvatar({ accessToken, apiUrl, avatar }) {
  const formData = new FormData();
  formData.append("avatar", avatar);
  const response = await axios.post(
    endpoint(apiUrl, "/users/me/avatar"),
    formData,
    authConfig(accessToken),
  );

  return response.data;
}

export async function getPublicUserProfile({ apiUrl, userId }) {
  const response = await axios.get(endpoint(apiUrl, `/users/${userId}`));

  return response.data;
}

export async function getPublicUserReviews({ apiUrl, userId }) {
  const response = await axios.get(endpoint(apiUrl, `/users/${userId}/reviews`));

  return response.data;
}
